import React from "react";
import { useNavigate } from "react-router";
import { Card, CardMedia, Box, Typography } from "@mui/material";
import AirlineSeatIndividualSuiteIcon from "@mui/icons-material/AirlineSeatIndividualSuite";
import classes from "./ShelterEntry.module.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HomeIcon from "@mui/icons-material/Home";

function ShelterEntry(props) {
  const navigate = useNavigate();
  const { photo, name, street, openingHours, capacity, usedCapacity, id } =
    props;
  const capacityColor = usedCapacity < capacity ? "#1a744d" : "red";
  return (
    <Card
      className={classes.card}
      onClick={() => {
        navigate(`/noclaharne/${id}`);
      }}
    >
      <CardMedia
        className={classes.photoPart}
        component="img"
        image={photo}
        alt="Shelter thumbnail"
        sx={{ width: 300 }}
      />
      <Box className={classes.textPart}>
        <Typography component="div" variant="h3">
          {name}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: 300, display: "flex", alignItems: "center" }}
        >
          <HomeIcon
            sx={{
              height: 40,
              width: 40,
              paddingRight: 1,
              alignContent: "center"
            }}
          />
          {street}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: 300, display: "flex", alignItems: "center"  }}
        >
          <AccessTimeIcon
            sx={{
              height: 40,
              width: 40,
              paddingRight: 1,
            }}
          />
          {openingHours.from}-{openingHours.to}
        </Typography>
      </Box>
      <Box className={classes.iconPart} sx={{ color: capacityColor }}>
        <Typography variant="h2" component="div">
          {usedCapacity}/{capacity}
        </Typography>
        <AirlineSeatIndividualSuiteIcon
          sx={{
            fontSize: "120px",
          }}
        />
      </Box>
    </Card>
  );
}

export default ShelterEntry;
